(() => {
  const carousels = Array.from(document.querySelectorAll('[data-featured-bundle-carousel]'));
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const track = carousel.querySelector('[data-featured-bundle-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-featured-bundle-slide]'));
    const dotsRoot = carousel.querySelector('[data-featured-bundle-dots]');
    if (!track || slides.length < 2 || !dotsRoot) return;

    dotsRoot.innerHTML = '';
    const dots = slides.map((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'featured-bundle__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', `Go to bundle image ${i + 1}`);
      dot.addEventListener('click', () => {
        const slideW = slides[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(track).gap || '0');
        track.scrollTo({
          left: i * (slideW + gap),
          behavior: 'smooth',
        });
      });
      dotsRoot.appendChild(dot);
      return dot;
    });

    const setActive = (idx) => {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    };

    const indexFromScroll = () => {
      const left = track.scrollLeft;
      const slideW = slides[0].getBoundingClientRect().width;
      if (!slideW) return 0;
      return Math.round(left / (slideW + parseFloat(getComputedStyle(track).gap || '0')));
    };

    let raf = null;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        setActive(Math.max(0, Math.min(slides.length - 1, indexFromScroll())));
      });
    };

    track.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();

